<div class="wrapper">
  <div class="emr-page-container">
    <div class="emr-page-title">{{ currentUser.firstName }}'s List of Patients</div>
    <div class="patient-list-header">
      @if (isAdmin) {
        <div class="btn-container">
          <button pButton pRipple type="button" label="New Patient" icon="pi pi-plus"
          [routerLink]="createPatientPath"></button>
          <!-- <button
          pButton
          pRipple
          type="button"
          label="Import CSV"
          icon="pi pi-upload"
          [disabled]="true"
          (click)="openImportPatientsDialog()"
        ></button> -->
        <button pButton pRipple type="button" label="Share Patients" icon="pi pi-share-alt"
        [disabled]="!didSelectPatients" (click)="openSharePatientsDialog()"></button>
        <button pButton pRipple type="button" label="Delete Patients" class="p-button-danger" icon="pi pi-trash"
        [disabled]="!didSelectPatients" (click)="openDeletePatientsDialog()"></button>
      </div>
    }
    <div class="dialog-container">
      <emr-confirmation-dialog title="Delete Patients" [(display)]="showDeletePatientsDialog"
        (dialogClose)="onCloseDeletePatientsDialog($event)" [confirmDisabled]="!confirmDeletePatients">
        <p>You are about to delete the following patients:</p>
        <ul>
          @for (patient of selectedPatients; track patient) {
            <li>
              {{ patient.getNameFirstMiddleLast() }} ({{ patient.id }})
            </li>
          }
        </ul>
        <p>This will also delete these patients for all users they are assigned to.</p>
        <p>Are you sure you would like to continue?</p>
        <p-checkbox [binary]="true" id="deleteSelectedPatientsChckBox"
        [(ngModel)]="confirmDeletePatients"></p-checkbox>
        <label class="label-right-of-box" for="deleteSelectedPatientsChckBox">I want to delete the above
        patients.</label>
      </emr-confirmation-dialog>
    </div>
  </div>

  <div class="dialog-container">
    <p-dialog header="Share Patients" [(visible)]="showSharePatientDialog" [modal]="true" [closable]="true"
      [style]="{width: '600px'}">
      <p>Share the following patients with selected administrators:</p>
      <ul>
        @for (patient of selectedPatients; track patient) {
          <li>
            {{ patient.getNameFirstMiddleLast() }}
          </li>
        }
      </ul>
      <p><strong>Select administrators to share with:</strong></p>

      <div class="p-fluid" style="margin: 1rem 0;">
        <p-table [value]="otherAdministrators" [(selection)]="selectedAdminsForSharing" dataKey="id"
          [loading]="isLoadingAdmins">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 3rem">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
              </th>
              <th>Name</th>
              <th>Email</th>
              <th>Status</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-admin>
            <tr>
              <td>
                <p-tableCheckbox [value]="admin" [disabled]="admin.alreadyHasPatient"></p-tableCheckbox>
              </td>
              <td>{{ admin.firstNameLastName }}</td>
              <td>{{ admin.email }}</td>
              <td>
                @if (admin.alreadyHasPatient) {
                  <span class="p-badge p-badge-success">Already shared</span>
                }
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="4" style="text-align: center; padding: 2rem">
                No other administrators found.
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <ng-template pTemplate="footer">
        <button pButton type="button" label="Cancel" class="p-button-text"
        (click)="showSharePatientDialog = false"></button>
        <button pButton type="button" label="Share Patients" (click)="sharePatientsWithAdmins()"
        [disabled]="selectedAdminsForSharing.length === 0"></button>
      </ng-template>
    </p-dialog>
  </div>

  <div class="table-container">
    <app-patient-table type="main" [patients]="patients" [(selectedPatients)]="selectedPatients"
    [loading]="isLoading"></app-patient-table>
  </div>
</div>
</div>